"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageServiceContextProvider = exports.ImageServiceContext = void 0;
const react_1 = __importStar(require("react"));
/**
 * Default configuration for the image service
 */
const defaultConfig = {
    serviceUrl: '',
    enableEnhancement: false,
    webpEnabled: false
};
/**
 * React context for image service configuration
 */
exports.ImageServiceContext = (0, react_1.createContext)({
    config: defaultConfig,
    updateConfig: () => {
        return;
    }
});
const ImageServiceContextProvider = ({ children, config: initialConfig = {} }) => {
    const [config, setConfig] = react_1.default.useState(Object.assign(Object.assign({}, defaultConfig), initialConfig));
    const updateConfig = react_1.default.useCallback((newConfig) => {
        setConfig((prevConfig) => (Object.assign(Object.assign({}, prevConfig), newConfig)));
    }, []);
    const contextValue = react_1.default.useMemo(() => ({
        config,
        updateConfig
    }), [config, updateConfig]);
    return (react_1.default.createElement(exports.ImageServiceContext.Provider, { value: contextValue }, children));
};
exports.ImageServiceContextProvider = ImageServiceContextProvider;
//# sourceMappingURL=ImageServiceProvider.js.map